import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { UserAuthService } from 'src/app/modules/auth/services/user.service';

@Injectable()
export class AuthPermissionGuard implements CanActivate {
    constructor(
        private router: Router,
        private userAuthService: UserAuthService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return new Promise<boolean>(async resolve => {
            const requiredPerms: string[] = next.data['permissions'];
            if (requiredPerms) {
                const hasAccess: Boolean =
                    this.userAuthService.hasPermissions(requiredPerms);
                if (hasAccess) {
                    resolve(true);
                } else {
                    this.userAuthService.navigateToUnauthorised();
                }
            } else {
                resolve(true);
            }
        });
    }
}
